import { render, staticRenderFns } from "./service-info-input-simple.vue?vue&type=template&id=b808886a&scoped=true&"
import script from "./service-info-input-simple.vue?vue&type=script&lang=js&"
export * from "./service-info-input-simple.vue?vue&type=script&lang=js&"
import style0 from "./service-info-input-simple.vue?vue&type=style&index=0&id=b808886a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b808886a",
  null
  
)

export default component.exports